<template>
  <b-dropdown right text="Acciones" class="action-legal">
    <b-dropdown-item @click="goEdit(row.id)"
      >Editar<img
        src="@/assets/images/icons/icon-edit.svg"
        alt="Descargar Reporte"
    /></b-dropdown-item>
    <b-dropdown-item @click="goEvaluate(row.id)"
      >Evaluar<img src="@/assets/images/icons/icon-document.svg" alt="Evaluar"
    /></b-dropdown-item>
    <b-dropdown-item @click="downloadReport(row.id, row.file_number)"
      >Reporte<img
        src="@/assets/images/icons/icon-pdf.svg"
        alt="Descargar Reporte"
    /></b-dropdown-item>
    <b-dropdown-item @click="documentation(row.id)"
      >Documentación<img
        src="@/assets/images/icons/iconfolder.svg"
        alt="Descargar Reporte"
    /></b-dropdown-item>
    <b-dropdown-item @click="goHistory(row.id)"
      >Historial<img
        src="@/assets/images/icons/history-gray.svg"
        alt="Historial Modificaciones"
    /></b-dropdown-item>
    <b-dropdown-item
      class="text-danger"
      v-if="this.user.core_role_id === 21"
      @click="confirmDelete(row.id)"
    >
      Eliminar<img
        src="@/assets/images/icons/icon-delete-red.svg"
        alt="Eliminar"
    /></b-dropdown-item>
  </b-dropdown>
</template>

<script>
// services
import processSevices from "@/services/legal/service.js";

export default {
  name: "ActionsLegal",
  props: ["row"],
  emits: ["deleteProcess"],
  methods: {
    goEdit(id) {
      this.$router.push(`/legal/process/${id}`);
    },
    goEvaluate(id) {
      this.$router.push(`/legal/process/evaluate/${id}`);
    },
    goHistory(id) {
      this.$router.push(`/legal/process/history/${id}`);
    },
    confirmDelete(id) {
      this.$bvModal.show("modal-delete");
      this.$store.dispatch(`process/setDelete`, { id: id });
    },
    downloadReport(id, file_number) {
      processSevices.getDownloadProcess(id).then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response], { type: "application/pdf" })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${file_number}.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    documentation(id) {
      const me = this;
      me.$router.push({ name: "Legal_documentation", params: { id } });
    },
  },
};
</script>

<style lang="scss" scope>
.action-legal .dropdown-item {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  display: flex !important;
  align-items: center;
  color: #546e7a !important;
  margin-bottom: 0px;
  justify-content: space-between;
  padding: 0 !important;
}

.text-danger {
  .action-legal .dropdown-item {
    color: #ac0000 !important;
  }
}

.dropdown-menu.show {
  background: #ffffff;
  //width: 112px;
  width: auto;
  border: 1px solid #b0bec5;
  border-radius: 8px;
  padding: 4px;
}

.action-legal .dropdown-toggle {
  color: #546e7a !important;
  font-family: "Ubuntu" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 28px !important;
  border: 1px solid #b0bec5 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
}
</style>
